<template>
  <div class="header-block">
    <h2>To check on your client status, please call.</h2>
    <p><a href="tel:+18883123524">888.312.3524 <span>Tap to Call</span></a></p>
  </div>  
</template>

<script>

export default {
  name: 'ChangeLocation'
}
</script>

<style scoped>
p { text-align: center; }
p a { 
	color: var(--yellow); 
	display: inline-block; 
	padding: 10px 20px; 
	font-size: 2em; 
	border: solid 1px #ccc; 
	border-radius: 4px; 
	text-decoration: none;
	text-align:  center;
	font-weight: 900;
}
p a span { 
	display: block; 
	font-size: 0.6em; 
	color: #ccc; 
	font-weight: normal; 
}
</style>